module.exports = __webpack_public_path__ + "Frame420-e89980a3.webp";